import { isbot } from 'isbot'
import {
  getAuth,
  signInAnonymously,
} from 'firebase/auth'
import UserDataService from "./../services/UserDataService";
//import router from '@/router'

export const  authentication =  async function () {
  const isBot = isbot(navigator.userAgent);
  if (!isBot) {
    const auth = getAuth()
    if (auth.currentUser === null) {
        signInAnonymously(auth)
        .then((firebaseUser) => {
         console.log("Signed in anonymously");
         const user = firebaseUser.user;
            const newUser = {
                uid: user.uid,
                displayName: user.displayName,
                emailVerified: user.emailVerified,
                anonymous: true,
                created: new Date()
            };
    
           UserDataService.createUser(newUser);
           return true;
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Error: ", errorCode, errorMessage);   
        });
    }
    return;
  }  
} 